import { render, staticRenderFns } from "./TourContent.vue?vue&type=template&id=3619ab39"
import script from "./TourContent.vue?vue&type=script&lang=js"
export * from "./TourContent.vue?vue&type=script&lang=js"
import style0 from "./TourContent.vue?vue&type=style&index=0&id=3619ab39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports